export var PageTargetFlags;
(function (PageTargetFlags) {
    PageTargetFlags["IsCaseInsensitive"] = "isCaseInsensitive";
})(PageTargetFlags || (PageTargetFlags = {}));
//# sourceMappingURL=page-target-flags.enum.js.map